import { AjaxRequestParams, AjaxResponse } from "Services/AjaxRequestParams";
import { ActionType, AdminPostModel, DEFAULT_ADMIN_POST_MODEL } from "./DynamicSettings";

export const submitActionOnlyPost = async (
	actionName: ActionType,
	ajaxRequest: (request: AjaxRequestParams) => Promise<AjaxResponse<string>>
) => {
	const postBody: AdminPostModel = { ...DEFAULT_ADMIN_POST_MODEL, ActionType: actionName };
	await ajaxRequest({ url: "/samuraijack", body: postBody });
	window.location.reload();
};

export const submitTimetablePost = async (
	TTFrom: string,
	TTTo: string,
	ajaxRequest: (request: AjaxRequestParams) => Promise<AjaxResponse<string>>
) => {
	const postBody: AdminPostModel = { ...DEFAULT_ADMIN_POST_MODEL, TTFrom, TTTo, ActionType: "invalidate_timetable" };
	await ajaxRequest({ url: "/samuraijack", body: postBody });
	window.location.reload();
};

export const submitPagePost = async (
	pageAlias: string,
	ajaxRequest: (request: AjaxRequestParams) => Promise<AjaxResponse<string>>
) => {
	const postBody: AdminPostModel = {
		...DEFAULT_ADMIN_POST_MODEL,
		PageAlias: pageAlias,
		ActionType: "invalidate_page",
	};
	await ajaxRequest({ url: "/samuraijack", body: postBody });
	window.location.reload();
};
